import { createAction } from '@reduxjs/toolkit';

/**
 * Refresh the "Collection" sidebar badge (#748): the client imports still
 * waiting for Invyo. Dispatched by the SideNav on every admin route change.
 */
export const pendingCountRequested = createAction('clientImportAlerts/pendingCountRequested');
